import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableBoolean, nullableString } from '../utils/wire-value-utils';
import { AuthorType } from './author-type.model';
import { ThreadDirection } from './thread-direction.model';
import { ThreadType } from './thread-type.model';

/**
 * A support ticket conversation entry (`GET /support-tickets/:id/threads`). Read-only on the web; replies
 * are posted as a `SupportTicketThreadRequest`. Fields the hub didn't send stay `undefined`.
 */
export class SupportTicketThread extends Base {
  ticketId?: string | null;
  threadType?: ThreadType | null;
  direction?: ThreadDirection | null;
  channel?: string | null;
  content?: string | null;
  contentType?: string | null;
  summary?: string | null;
  isPublic?: boolean | null;
  authorType?: AuthorType | null;
  authorName?: string | null;
  authorEmail?: string | null;
  createdByProfileId?: string | null;
  createdByName?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.ticketId = nullableString(source['ticketId']);
    this.threadType = nullableString(source['threadType']) as ThreadType | null | undefined;
    this.direction = nullableString(source['direction']) as ThreadDirection | null | undefined;
    this.channel = nullableString(source['channel']);
    this.content = nullableString(source['content']);
    this.contentType = nullableString(source['contentType']);
    this.summary = nullableString(source['summary']);
    this.isPublic = nullableBoolean(source['isPublic']);
    this.authorType = nullableString(source['authorType']) as AuthorType | null | undefined;
    this.authorName = nullableString(source['authorName']);
    this.authorEmail = nullableString(source['authorEmail']);
    this.createdByProfileId = nullableString(source['createdByProfileId']);
    this.createdByName = nullableString(source['createdByName']);
  }
}
